"use strict";

var _slicedToArray = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XYZColor = void 0;

var RGBColor_1 = require("./RGBColor");

var LABColor_1 = require("./LABColor");
/**
 * Represents the CIE XYZ color space.
 */


var XYZColor = /*#__PURE__*/function () {
  /**
   * Creates new XYZ color.
   * @param x - x-component in the range [0, 1].
   * @param y - y-component in the range [0, 1].
   * @param z - z-component in the range [0, 1].
   */
  function XYZColor(x, y, z) {
    _classCallCheck(this, XYZColor);

    this.values = [x, y, z];
  }
  /**
   * The x-component of the color.
   */


  _createClass(XYZColor, [{
    key: "toArray",

    /**
     * Return a copy of color values in array format as [x, y, z].
     */
    value: function toArray() {
      // copy
      return this.values.map(function (v) {
        return v;
      });
    }
    /**
     * Trasforms color to the RGB format.
     */

  }, {
    key: "toRGB",
    value: function toRGB() {
      var _this$values = _slicedToArray(this.values, 3),
          x = _this$values[0],
          y = _this$values[1],
          z = _this$values[2];

      var r = +3.2406255 * x - 1.5372080 * y - 0.4986286 * z;
      var g = -0.9689307 * x + 1.8757561 * y + 0.0415175 * z;
      var b = +0.0557101 * x - 0.2040211 * y + 1.0569959 * z;
      return new RGBColor_1.RGBColor(r, g, b);
    }
    /**
     * Trasforms color to the sRGB format.
     */

  }, {
    key: "toSRGB",
    value: function toSRGB() {
      return this.toRGB().toSRGB();
    }
    /**
     * Trasforms color to the CIE LAB format.
     */

  }, {
    key: "toLAB",
    value: function toLAB() {
      var x = this.x / XYZColor.D65.x;
      var y = this.y / XYZColor.D65.y;
      var z = this.z / XYZColor.D65.z;
      var xyz = [x, y, z].map(function (v) {
        if (v > 0.008856451) {
          return Math.pow(v, 1 / 3);
        } else {
          return 7.787037 * v + 16 / 116;
        }
      });
      return new LABColor_1.LABColor((116 * xyz[1] - 16) / 100, 5 * (xyz[0] - xyz[1]), 2 * (xyz[1] - xyz[2]));
    }
  }, {
    key: "x",
    get: function get() {
      return this.values[0];
    }
    /**
     * The y-component of the color.
     */

  }, {
    key: "y",
    get: function get() {
      return this.values[1];
    }
    /**
     * The z-component of the color.
     */

  }, {
    key: "z",
    get: function get() {
      return this.values[2];
    }
  }]);

  return XYZColor;
}();

exports.XYZColor = XYZColor;
/**
 * The D65 white point vector.
 */

XYZColor.D65 = new XYZColor(0.95047, 1.000, 1.08883);
/**
 * The D50 white point vector.
 */

XYZColor.D50 = new XYZColor(0.966797, 1.000, 0.825188);